module.exports = "<div ng-if=\"$ctrl.counterOptions\" \n     class=\"gridCounterStyle\" \n     ui-grid-edit \n     ui-grid-row-edit\n     ui-grid-selection\n     ui-grid=\"$ctrl.counterOptions\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/counter-dashboard/counter-dashboard.html
// module id = 101
// module chunks = 0